import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { PropertyChangeEvent, MANUAL_EDIT } from '../../models/property-change-event';
import { NavigationService } from '../../../core/navigation.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchService } from '../../search/search.service';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchStatus } from '../../search/models/search-status.model';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { Clause } from '../../search/models/search-filter-model';
import { SearchEvent } from '../../search/models/search-event';
import { ITEM_AUTO_POPULATE } from '../../search/search-constants';
import { LookupInputComponent } from '../lookup-input/lookup-input.component';
import { CoreServiceRegistry } from '../../../core/core-service-registry';

@Component({
  selector: 'lfwms-lookup-filter-input',
  templateUrl: './lookup-filter-input.component.html',
  styleUrls: ['./lookup-filter-input.component.css']
})
export class LookupFilterInputComponent extends LookupInputComponent {

  @Input() public clause: Clause;
  @Input() public condition: Clause;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

/*Earlier the function had only two inputs whereas in parent there was 3 inputs for
 the function(which is required)
Hence changed to match with parent function to resolve Jira 1616 */
  public handleSuggestionSelected(suggestioncellDataMap, key, suggestion) {
    const event = { target: { value: suggestion } };
    this.valueChanged(event);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/lookup-filter-input/lookup-filter-input.component.ts